import type { RouteObject } from 'react-router';

import * as searchEventsHorizonRouteExports from '#/modules/search/events/page/SearchEvents.horizon-route';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

import { searchEventsRoutePaths } from './searchEvents.route-paths';

const searchEventsRouteObject = horizonRouteToObject(
  searchEventsHorizonRouteExports,
);
const createSearchEventsRouteObject = (path: string): RouteObject => ({
  path,
  ...searchEventsRouteObject,
});

export const searchEventsRouteObjects = searchEventsRoutePaths.map(
  createSearchEventsRouteObject,
) satisfies RouteObject[];
